import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import { MenuItem } from '../../../generic';

import type { Reference, Tag } from './types';

import styles from './BranchesDropdown.module.less';

type Props = {
  tag: Tag;
  onClick: (reference: Reference) => void;
};

/**
 * Displays a single tag item.
 */
const TagItem: VoidFunctionComponent<Props> = ({
  tag,
  onClick,
}) => {
  return (
    <MenuItem
      className={cx(styles.dropdownMenuReference, {
        // The selected tag has a green background.
        [styles.dropdownMenuReferenceSelected]: tag.isSelected,
      })}
      onClick={() => onClick(tag)}
    >
      {tag.name}
    </MenuItem>
  );
};

export default TagItem;
